import { useEffect } from "react";

import { usePostHog } from "@posthog/react";

import { useAppSelector } from "../../Store/Hooks";
import {
  getFromLocalStorage,
  STORAGE_KEYS,
} from "../../Utils/Helper/LocalStorage";

const PostHogIdentify = () => {
  const posthog = usePostHog();
  const { user } = useAppSelector(state => state.authentication);

  useEffect(() => {
    if (!posthog) return;

    const stored = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
    const authUser = user?.user;

    const userId = authUser?.user_id || stored?.userId;
    if (!userId) return;

    const orgId = authUser?.tenant_id || stored?.tenantId;
    const orgName = authUser?.tenant_name || stored?.tenantName;
    const orgSlug = authUser?.slug || stored?.slug;

    posthog.identify(String(userId), {
      email: authUser?.email || stored?.email,
      name: authUser?.full_name || stored?.fullName,
      role: authUser?.role || stored?.role,
      org_id: orgId,
      org_name: orgName,
      tenant_slug: orgSlug,
    });

    if (orgId) {
      posthog.group("organization", String(orgId), {
        name: orgName,
        slug: orgSlug,
      });
    }
  }, [posthog, user]);

  return null;
};

export default PostHogIdentify;
